var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpToLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 32H24C10.75 32 0 42.75 0 56S10.75 80 24 80H360C373.25 80 384 69.25 384 56S373.25 32 360 32ZM214.25 137.375C208 131.125 199.812 128 191.625 128S175.25 131.125 169 137.375L33.092 287.824C5.207 318.691 27.113 368 68.711 368H111.625V432C111.625 458.508 133.115 480 159.625 480H223.625C250.135 480 271.625 458.508 271.625 432V368H314.912C356.543 368 378.436 318.629 350.488 287.773L214.25 137.375ZM223.625 320V432H159.625V320H70.258L191.625 182.633L312.992 320H223.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpToLine);
export default __webpack_public_path__ + "static/media/up-to-line.5c0e48b0dce427869e3665f70c82c35f.svg";
export { ForwardRef as ReactComponent };